<template>
  <div class="recharge-record-page">
    <div class="recharge-record-container">
      <div class="header-box">
        <span class="recharge-date">消耗日期</span>
        <kx-date-picker 
          v-model="params.beginDate"
          :time-end.sync="params.endDate"/>
        <!--
        <el-date-picker
          class="btn-date-picker"
          v-model="time"
          type="daterange"
          :editable="false"
          :clearable="false"
          align="center"
          range-separator="-"
          placeholder="选择日期范围"
          :picker-options="pickerOptions"
        ></el-date-picker>
        -->
        <el-select
          class="ml10"
          v-model="params.country"
          placeholder="请选择站点"
          size="mini"
          clearable
          @change="orderList"
        >
          <el-option
            v-for="el in countryList"
            :key="el.cnt"
            :label="el.name"
            :value="el.cnt"
          ></el-option>
        </el-select>
        <el-button @click="orderList" v-pointerReClick>查询</el-button>
      </div>
      <div class="table-box">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          style="width: 100%"
          :height="getStyle"
          :header-cell-style="{ background: '#eef1f6' }"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单号"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="payDate"
            label="日期"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="description"
            label="消耗"
            align="center"
            width="190"
          >
          </el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <div
                :class="[
                  'align-left',
                  scope.row.goodsUrl ? 'table-oper-txt' : '',
                ]"
                @click="handleDownLoad(scope.row)"
                v-if="getIsShow(scope.row.histQueryExpireDate)"
              >
                {{ getSearchTxt(scope.row) }}
              </div>
              <el-popover
                v-else-if="scope.row.type == 'BATCH_SEARCH'"
                placement="bottom"
                width="300"
                trigger="hover"
                content="超过72小时不能下载，如有疑问，请联系右侧客户经理"
              >
                <div slot="reference" class="align-left">
                  {{ getSearchTxt(scope.row) }}
                </div>
              </el-popover>
              <div class="align-left" v-else>
                {{ getSearchTxt(scope.row) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="175">
            <template slot-scope="scope">
              <div class="align-left">
                <!-- 申诉中 -->
                <el-popover
                  v-if="scope.row.orderStatus === '04'"
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="申诉中，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉中</span>
                </el-popover>
                <!-- 申诉成功 -->
                <el-popover
                  v-else-if="scope.row.orderStatus === '05'"
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="申诉成功，已返回积分，请注意查收，如有疑问请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉成功</span>
                </el-popover>

                <!-- 申诉失败 -->
                <el-popover
                  v-else-if="scope.row.orderStatus === '06'"
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="申诉驳回，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉驳回</span>
                </el-popover>

                <el-popover
                  v-else-if="scope.row.description === '0个积分'"
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="不扣积分，不能申诉，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉</span>
                </el-popover>
                <el-popover
                  v-else-if="scope.row.type == 8"
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="暂不支持申诉，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉</span>
                </el-popover>
                <!-- 搜索2小时之内的状态 -->
                <span
                  class="table-oper-txt"
                  @click="opergetBackDV(scope.row)"
                  v-else-if="getTime(scope.row)"
                  >申诉</span
                >
                <el-popover
                  v-else
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  content="超过2小时，无法申诉，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">申诉</span>
                </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <dialog-appeal
        :record="row"
        :visible.sync="getBackDV"
        @update-success="() => orderList()"/>
      <!--
      <el-dialog
        title="申诉"
        :visible.sync="getBackDV"
        width="600px"
        :before-close="closegetBackDV"
        class="get-back-DV"
        :close-on-click-modal="false"
      >
        <el-form
          ref="getBackForm"
          :model="getBackForm"
          class="get-back-form"
          label-width="80px"
          :rules="rules"
          v-loading="imgLoading"
        >
          <el-form-item label="申诉原因" prop="reasons">
            <el-checkbox-group v-model="getBackForm.reasons">
              <el-checkbox
                :label="item"
                name="type"
                v-for="(item, index) in reason"
                :key="index"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="问题描述" prop="details">
            <el-input
              type="textarea"
              v-model="getBackForm.details"
              placeholder="请输入"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="凭证信息" prop="complaintUrls">
            <div class="img-list">
              <template v-if="getBackForm.complaintUrls.length > 0">
                <div
                  v-for="(item, index) in getBackForm.complaintUrls"
                  :key="index"
                  class="avatar"
                >
                  <img :src="item" />
                  <i class="el-icon-error" @click="tapDeleteImg(index)"></i>
                </div>
              </template>
              <el-upload
                class="avatar-uploader"
                action="/api/upload/image"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :data="{ type: 'complaint' }"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="format-type">仅支持jpg/png格式，文件大小5M以内</div>
          </el-form-item>
          <el-form-item label="验证码" class="code" prop="captcha">
            <el-input
              v-model="getBackForm.captcha"
              placeholder="请输入"
            ></el-input>
            <div class="img-code">
              <img :src="imgCode" @click="tapCutImg" />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closegetBackDV" class="cancel-btn"
            >取 消</el-button
          >
          <el-button @click="tapGetBack" class="get-back-bnt">申诉</el-button>
        </span>
      </el-dialog>
      -->
    </div>
  </div>
</template>

<script>
import { orderList, queryComplaintReason, complaint } from '@/api/user.js'
import { myMixin } from '@/mixins/mixin.js'
import KxDatePicker from '@/components/KxDatePicker'
import DialogAppeal from '@/components/dialog/DialogAppeal.vue'
import {
  countryer,
} from '@/api/home'
export default {
  name: 'useRecord',
  components: { 
    KxDatePicker,
    DialogAppeal,
  },
  props: {},
  mixins: [myMixin],
  data() {
    return {
      countryList: [],
      row: {},
      params: {
        country: '',
        pageNo: 1,
        pageSize: 10,
        beginDate: '',
        endDate: ''
      },
      time: ['', ''],
      tableData: [],
      total: 0,
      getBackDV: false,
      getBackForm: {
        reasons: [],
        reason: '',
        details: '',
        complaintUrls: [],
        orderNo: '',
        captcha: ''
      },
      rules: {
        reasons: [
          {
            type: 'array',
            required: true,
            message: '至少选择一个原因',
            trigger: 'change'
          }
        ],
        details: [
          { required: true, message: '请填写问题描述', trigger: 'blur' }
        ],
        complaintUrls: [
          {
            type: 'array',
            required: true,
            message: '至少上传一张图片',
            trigger: 'change'
          }
        ],
        captcha: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ]
      },
      reason: [],
      imgCode: '/api/captcha/get?type=bindMobile',
      loading: false,
      imgLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      }
    }
  },
  computed: {
    getStyle() {
      if (this.tableData.length > 0) {
        return '100%'
      } else {
        return 'auto'
      }
    }
  },
  watch: {},
  created() {
    /*
    this.time = [new Date(this.getStartDate()), new Date()]
    */
    this.params = Object.assign(this.params, {
      beginDate: this.format(new Date(this.getStartDate())),
      endDate: this.format(new Date())
    })
    this.orderList()
    this.getCountryList()
  },
  methods: {
    async getCountryList() {
      const res = await countryer()
      const { code, data } = res
      if (code == 200) {
        this.countryList = data
      }
    },
    // 获取使用记录信息
    orderList() {
      this.loading = true
      /*
      this.params.beginDate = this.format(this.time[0])
      this.params.endDate = this.format(this.time[1])
      */
      orderList(this.params).then(res => {
        this.loading = false
        if (res.success) {
          this.tableData = res.data.data || []
          this.total = res.data.totalRecord
        }
      })
    },
    getIsShow(time) {
      return +new Date() >= new Date(time) ? false : true
    },
    getSearchTxt(val) {
      if (val.type == 7) {
        return '点击下载查询结果'
      } else {
        return val.content
      }
      // if (val.type == 7) {
      //   return '点击下载查询结果'
      // } else if (val.searchType == 1) {
      //   return `Name：${val.username} Helpful Votes：${
      //     val.helpfulVoteNumber
      //   } Reviews：${val.reviewNumber} Addr：${val.location ||
      //     ''} Review Date：${val.latestReviewDate || ''}`
      // } else {
      //   return 'Profile：' + val.profileId
      // }
    },
    handleDownLoad(row) {
      if (row.goodsUrl) {
        window.open(row.goodsUrl)
      }
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.orderList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.orderList()
    },
    getTime(row) {
      if (+new Date() - new Date(row.payDate) > 1000 * 60 * 60 * 2) {
        return false
      } else {
        return true
      }
    },
    // 获取订单申诉原因列表
    queryComplaintReason() {
      queryComplaintReason().then(res => {
        this.reason = res.data
        this.getBackDV = true
      })
    },
    // 获取图形验证码
    tapCutImg() {
      this.imgCode = '/api/captcha/get?type=bindMobile' + +new Date()
    },
    // 打开弹窗
    opergetBackDV(row) {
      this.row = row
      this.getBackDV = true
      /*
      this.getBackForm.orderNo = row.orderNo
      this.queryComplaintReason()
      */
    },
    // 关闭弹窗
    closegetBackDV() {
      this.getBackDV = false
      this.$refs['getBackForm'].resetFields()
      this.getBackForm = {
        reasons: [],
        reason: [],
        details: '',
        complaintUrls: [],
        orderNo: '',
        captcha: ''
      }
      this.tapCutImg()
    },
    // 申诉
    tapGetBack() {
      this.$refs['getBackForm'].validate(valid => {
        if (valid) {
          this.getBackForm.reason = this.getBackForm.reasons.join(',')
          complaint(this.getBackForm).then(res => {
            if (res.success) {
              this.$message.success('提交申诉成功')
              this.closegetBackDV()
              this.orderList()
            } else {
              this.tapCutImg()
            }
          })
        } else {
          return false
        }
      })
    },
    // 获取图片
    handleAvatarSuccess(res) {
      // console.log(file);
      this.imgLoading = false
      if (res.success) {
        // URL.createObjectURL(file.raw)
        this.getBackForm.complaintUrls.push(res.data)
        this.$message.success('图片上传成功')
      }
    },
    // 验证图片信息
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) this.$message.error('上传头像图片只能是JPG和PNG格式!')
      if (!isLt5M) this.$message.error('上传头像图片大小不能超过 5MB!')
      if (isJPG && isLt5M) {
        this.imgLoading = true
      }
      return isJPG && isLt5M
    },
    // 点击删除图片
    tapDeleteImg(index) {
      this.$confirm('您确认要删除该张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.closeAll()
        this.getBackForm.complaintUrls.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.recharge-record-page {
  position: relative;
  width: 1010px;
  height: 100%;
  padding: 20px;
  box-shadow: 0px 2px 12px 0px #edecf6;
  border-radius: 4px;
  .recharge-record-container {
    height: 100%;
  }
  .header-box {
    display: flex;
    align-items: center;
    .recharge-date {
      margin-right: 22px;
    }
    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 66px;
      height: 30px;
      background-color: #3c7cff;
      border-color: #3777ff;
      color: #fff;
      margin: 0 0 0 22px;
    }
    ::v-deep.el-input__inner {
      width: 180px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
    ::v-deep.el-icon-arrow-up {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep.el-date-editor {
    width: 200px !important;
    height: 30px;
    line-height: 30px !important;
    font-size: 12px !important;
    margin-right: 18px;

    .el-range-input {
      font-size: 12px;
    }

    .el-icon-date {
      margin-top: -8px;
      &::before {
        margin-right: -360px;
      }
    }

    .el-range__icon {
      margin-left: -22px;
    }

    .el-range-separator {
      line-height: 22px;
    }
  }
  .table-box {
    height: calc(100% - 100px);
    margin-top: 20px;
    ::v-deep.has-gutter {
      color: #373e4f;
    }
    .link-url {
      margin-right: 12px;
    }
    .table-oper-txt {
      cursor: pointer;
      color: #4f94f9;
    }
    .table-disabled {
      font-size: 14px;
      color: #a3aab7;
      cursor: no-drop;
    }
    .block {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .align-left {
      text-align: left !important;
    }
    .table-oper-txt {
      cursor: pointer;
      color: #4f94f9;
    }
  }
}

::v-deep.get-back-DV {
  .get-back-form {
    .el-form-item {
      margin-bottom: 18px;
    }
    .el-form-item__error {
      left: 28px;
    }
    .el-checkbox-group {
      display: flex;
      justify-content: space-between;
      padding: 0 32px 0 30px;
    }
    .el-textarea__inner {
      width: 420px;
      margin-left: 30px;
    }
    .el-input__count {
      background: transparent;
      bottom: -10px;
      right: 45px;
    }
    .code {
      position: relative;
      .el-input__inner {
        width: 348px;
        height: 38px;
        line-height: 38px;
        margin-left: 30px;
      }
      .img-code {
        position: absolute;
        top: 3px;
        right: 30px;
        width: 72px;
        height: 36px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .img-list {
    display: flex;
    padding-left: 30px;
    .avatar {
      position: relative;
      width: 60px;
      height: 60px;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
      i {
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;
      }
      i.el-icon-error {
        color: #FF455B;
        top: -8px;
        right: -8px;
        font-size: 16px;
      }
    }
  }
  .format-type {
    height: 30px;
    font-size: 14px;
    margin: -20px 0 0 28px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .el-upload__tip {
    margin: -20px 0 0 25px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    margin-top: -25px;
    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      height: 46px;
      font-size: 16px;
      color: #444b5b;
    }
    .get-back-bnt {
      color: #fff;
      background: linear-gradient(0deg, #0831ff, #3777ff);
      border-color: #3777ff;
    }
  }
}
</style>
